import { render } from "./terms.vue?vue&type=template&id=3d734d56&scoped=true"
import script from "./terms.vue?vue&type=script&lang=js"
export * from "./terms.vue?vue&type=script&lang=js"

import "./terms.vue?vue&type=style&index=0&id=3d734d56&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d734d56"]])

export default __exports__